import React from "react";
import "../../assets/css/meritCard.css";

const MeritCard = (props) => {
  return (
    <section className="merit-card-container">
      <img className="image-box" src={props.image} alt="merit画像" />
      <div className="merit-card-container--inner text-white yu-gothic">
        <div className="merit-card-headline">{props.title}</div>
        <div className="spacer-box--ss" />
        <div className="center">
          <div className="left inline-block merit-card-text">{props.textA}</div>
          <div className="left inline-block merit-card-text">{props.textB}</div>

          <div className="merit-card-notes">{props.notes}</div>
        </div>
      </div>
    </section>
  );
};
export default MeritCard;
